import React from 'react';
import { Switch, Route } from 'react-router';
import { useSelector } from 'react-redux';
import BillingPage from '../../billing/BillingPage';
import { selectUser } from '../../../store/modules/users/selectors';
import ProfileTopTabs from '../../profile/ProfileTopTabs';
import InvoicesPage from '../../billing/InvoicesPage';
import CreditHistoryPage from '../../billing/CreditHistoryPage';
import PaymentMethodPage from '../../billing/PaymentMethodPage';

const UserBilling = () => {

  const user = useSelector(selectUser);

  return (
    <>
      <ProfileTopTabs loading={user.loading} tabResource="billing" />
      <Switch>
        <Route exact path="/dashboard/admin/users/:id/billing/plan">
          <BillingPage user={user} />
        </Route>
        <Route exact path="/dashboard/admin/users/:id/billing/payment-method">
          <PaymentMethodPage user={user} />
        </Route>
        <Route exact path="/dashboard/admin/users/:id/billing/invoices">
          {user.data && <InvoicesPage user={user.data} />}
        </Route>
        <Route path="/dashboard/admin/users/:id/billing/credit-history">
          {user.data && <CreditHistoryPage user={user.data} />}
        </Route>
      </Switch>
    </>
  );
};

export default UserBilling;
